import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Container, Grid, GridItem, Heading, Link, Text, Stack, VStack, HStack } from "@chakra-ui/react";
import { USEFUL_LINKS, COURSE_LINKS, POLICY_LINKS } from "../../constants/routes";

const PUBLIC = process.env.PUBLIC_URL || "";

const SOCIAL_LINKS = [
  { to: "https://www.instagram.com/midas_taj_classes_pvt_ltd/", icon: "bi-instagram", label: "Instagram" },
  { to: "https://www.facebook.com/midastajclasses/", icon: "bi-facebook", label: "Facebook" },
  { to: "https://twitter.com/midastaj?lang=en", icon: "bi-twitter-x", label: "Twitter" },
  { to: "https://www.youtube.com/@MidasTajCoachingClassesPvtLtd", icon: "bi-youtube", label: "YouTube" },
];

function FooterLink({ to, children }) {
  return (
    <Link
      as={RouterLink}
      to={to}
      color="white"
      fontSize={{ base: "xs", sm: "sm" }}
      _hover={{ color: "brand.lightDarkYellow", textDecoration: "none" }}
    >
      {children}
    </Link>
  );
}

export default function Footer() {
  return (
    <>
      <Box as="footer" bg="brand.green" color="white" pt={{ base: 8, md: 10 }} pb={{ base: 5, md: 6 }}>
        <Container maxW="1100px" px={{ base: 4, md: 6 }}>
          <Grid
            templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", lg: "repeat(4, 1fr)" }}
            gap={{ base: 6, md: 8 }}
            mb={8}
          >
            {/* Brand column */}
            <GridItem>
              <VStack align="center" spacing={3} textAlign="center">
                <Box
                  as="img"
                  src={`${PUBLIC}/images/logo.png`}
                  alt="MIDAS TAJ"
                  w={{ base: "64px", sm: "72px", md: "80px" }}
                />
                <Heading
                  size="sm"
                  fontWeight="semibold"
                  lineHeight="tall"
                  textAlign="center"
                  fontSize={{ base: "md", sm: "lg", md: "xl" }}
                >
                  MIDAS TAJ CLASSES
                  <br />
                  PVT. LTD.
                </Heading>
                <HStack spacing={3}>
                  {SOCIAL_LINKS.map(({ to, icon, label }) => (
                    <Link
                      key={label}
                      href={to}
                      isExternal
                      aria-label={label}
                      color="brand.yellow"
                      _hover={{ color: "white" }}
                    >
                      <i className={`bi ${icon}`} style={{ fontSize: "1.2rem" }} />
                    </Link>
                  ))}
                </HStack>
              </VStack>
            </GridItem>

            {/* Address column */}
            <GridItem>
              <VStack align="flex-start" spacing={2} textAlign="left">
                <Heading size="sm" color="brand.yellow">
                  Address
                </Heading>
                <Text fontWeight="medium" color="brand.lightDarkYellow" fontSize={{ base: "xs", sm: "sm" }}>
                  Head Branch Office
                </Text>
                <Text fontSize={{ base: "xs", sm: "sm" }} lineHeight="tall">
                  WARD NO 15, near CHATRAPATI SHIVAJI MAHARAJ CHAWK, Gawande Colony, Sausar, Madhya Pradesh 480106
                </Text>
                <Text fontWeight="medium" color="brand.lightDarkYellow" fontSize={{ base: "xs", sm: "sm" }} pt={2}>
                  Phone Number
                </Text>
                <Text fontSize={{ base: "xs", sm: "sm" }}>07165-220666</Text>
                <Text fontWeight="medium" color="brand.lightDarkYellow" fontSize={{ base: "xs", sm: "sm" }} pt={2}>
                  Send us a Message
                </Text>
                <Text fontSize={{ base: "xs", sm: "sm" }}>midastajclasses@gmail.com</Text>
              </VStack>
            </GridItem>

            {/* Useful Links column */}
            <GridItem>
              <VStack align="flex-start" spacing={2}>
                <Heading size="sm" color="brand.yellow">
                  Useful Links
                </Heading>
                <Stack spacing={1}>
                  {USEFUL_LINKS.map((item) => (
                    <FooterLink key={item.label + item.path} to={item.path}>
                      {item.label}
                    </FooterLink>
                  ))}
                </Stack>
              </VStack>
            </GridItem>

            {/* Courses column */}
            <GridItem>
              <VStack align="flex-start" spacing={2}>
                <Heading size="sm" color="brand.yellow">
                  Courses
                </Heading>
                <Stack spacing={1}>
                  {COURSE_LINKS.map((item) => (
                    <FooterLink key={item.path} to={item.path}>
                      {item.label}
                    </FooterLink>
                  ))}
                </Stack>
              </VStack>
            </GridItem>
          </Grid>
        </Container>
      </Box>

      {/* Footer bottom bar */}
      <Box bg="brand.red" py={{ base: 3, md: 4 }}>
        <Container maxW="1100px" px={{ base: 4, md: 6 }}>
          <VStack spacing={{ base: 2, md: 3 }}>
            <Stack
              direction={{ base: "column", sm: "row" }}
              spacing={{ base: 1, sm: 2 }}
              justify="center"
              align="center"
            >
              <FooterLink to={POLICY_LINKS.RULES}>Rules And Regulations</FooterLink>
              <Text display={{ base: "none", sm: "inline" }} color="whiteAlpha.600">
                |
              </Text>
              <FooterLink to={POLICY_LINKS.REFUND}>Refund & Cancellation</FooterLink>
            </Stack>
            <Box borderTop="1px solid" borderColor="brand.yellow" opacity={0.6} my={2} />
            <Text fontSize={{ base: "xs", sm: "sm" }} color="white" textAlign="center">
              MIDAS TAJ CLASSES PVT. LTD. © All Rights Reserved.
            </Text>
          </VStack>
        </Container>
      </Box>
    </>
  );
}
